import { useEffect } from "react";
import { useContent } from "../context/ContentContext";

// Loads the Tawk.to live-chat widget from the ID configured in the admin (settings.tawkto).
// Accepts either "propertyId/widgetId" or a full embed.tawk.to URL.
export const TawkChat = () => {
  const { content } = useContent();
  const raw = content?.settings?.tawkto?.trim();

  useEffect(() => {
    if (!raw) return;
    let path = raw;
    const m = raw.match(/embed\.tawk\.to\/(.+)$/);
    if (m) path = m[1];
    path = path.replace(/^\/+|\/+$/g, "");
    if (!path.includes("/")) return; // need propertyId/widgetId

    if (document.getElementById("tawkto-script")) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.id = "tawkto-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${path}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.body.appendChild(s);
  }, [raw]);

  return null;
};
